(() => {
  /** @type {Window & { themeAfterPageReveal?: (fn: () => void) => void }} */
  const themeWindow = window;

  if (typeof themeWindow.themeAfterPageReveal === "function") return;

  /** @type {Array<() => void>} */
  const queue = [];
  let scheduled = false;

  function flush() {
    const callbacks = queue.splice(0);
    callbacks.forEach((fn) => fn());
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    const trigger = () => {
      requestAnimationFrame(() => requestAnimationFrame(flush));
    };
    if (document.readyState !== "loading") {
      trigger();
    } else {
      document.addEventListener("DOMContentLoaded", trigger, { once: true });
    }
  }

  /**
   * All callbacks registered via themeAfterPageReveal are flushed together
   * in a single double-rAF batch — guaranteed same animation frame.
   * @param {() => void} fn
   */
  themeWindow.themeAfterPageReveal = function themeAfterPageReveal(fn) {
    queue.push(fn);
    schedule();
  };
})();

export {};
